import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ icon, label, value, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    secondary: 'bg-secondary/10 text-secondary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    accent: 'bg-accent/10 text-accent-foreground'
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start justify-between">
        <div className="space-y-2 flex-1">
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="text-2xl md:text-3xl font-bold text-foreground whitespace-nowrap">
            {value}
          </p>
          {trend && (
            <div className="flex items-center gap-1">
              <Icon
                name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'}
                size={14}
                className={trend === 'up' ? 'text-success' : 'text-destructive'}
              />
              <span className={`text-xs font-medium ${trend === 'up' ? 'text-success' : 'text-destructive'}`}>
                {trendValue}
              </span>
              <span className="text-xs text-muted-foreground">vs last month</span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${colorClasses?.[color]} flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default StatsCard;